import { checkBit } from '../../Utils/Functions';
import './DmRezIn.css';

export default function DmRezIn({status, islink} ) {

    const rezInRun = checkBit(status, 2)
    return(
        <> 
            {islink==='Online' && rezInRun && (
            <div className='rezInInfo'>
                <p>IN</p>
            </div>
            )}
        </>

    )
}